import axios from "axios";
import { URL } from "../../config/config";

const BASE = `${URL}/superadmin/ad-template-analytics`;

function normalize(promise) {
  return promise
    .then((res) => ({
      data: res.data && res.data.data !== undefined ? res.data.data : null,
      rate: (res.data && res.data.rate) || null,
      notFound: false,
      error: null,
    }))
    .catch((err) => {
      const notFound = err?.response?.status === 404;
      return {
        data: null,
        rate: null,
        notFound,
        error: notFound
          ? null
          : err?.response?.data?.message || err?.message || "Request failed",
      };
    });
}

export function fetchAnalytics(path, params) {
  return normalize(axios.get(`${BASE}/${path}`, { params }));
}
